module.exports = __webpack_public_path__ + "img/wave.0ad37763.svg";